import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Guards a route by role. Usage:
 *   <RoleProtectedRoute allow={['admin']}><AdminPage /></RoleProtectedRoute>
 *
 * - If not authenticated → /login (preserves return path).
 * - If authenticated but role not allowed → /access-denied.
 */
export default function RoleProtectedRoute({ allow = [], children }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const role = user?.role;
  if (allow.length && !allow.includes(role)) {
    return <Navigate to="/access-denied" replace />;
  }
  return children;
}
